import React from "react";
import { Helmet } from 'react-helmet-async';
import Section from "./Section";
import { Container } from "reactstrap";
import DashboardContent from "./DashboardContent";
import CreditPanel from "./CreditPanel";
import { useEffect } from "react";

const ManageJobApplications = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>Dashboard | Jobseekers Page </title>
      </Helmet>
      <Section />
      <section className='section'>
        <Container>
          <CreditPanel />

          <DashboardContent />
        </Container>
      </section>
    </React.Fragment>
  );
};

export default ManageJobApplications;
